import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { useGraphite } from "@/components/Graphite"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

// Graphite: a tag is a surface-2 fill with 6px corners and no border; a status colours its word, never the fill
const graphiteBadgeVariants = cva(
  "inline-flex items-center whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-gr-surface-2 text-foreground",
        destructive: "bg-gr-surface-2 text-gr-danger",
        outline: "bg-gr-surface-2 text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  const variants = useGraphite() ? graphiteBadgeVariants : badgeVariants
  return (<div className={cn(variants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
